import React from 'react';
import PropTypes from 'prop-types';

const ResultInfo = ({eventList, currentPage}) => {
    if (!eventList.length) {
        return null;
    }
    return (
        <div className="first:tw-mb-2 last:tw-my-2">
            Wyświetlono {currentPage * 20 > eventList.length ? eventList.length : currentPage * 20} z {eventList.length} wydarzeń
        </div>
    );
};

ResultInfo.propTypes = {
    eventList: PropTypes.array.isRequired,
    currentPage: PropTypes.number.isRequired,
};

export default ResultInfo;
